function CustomLandscapeWidest() {
    // check the width
    const deviceWidth = window.screen.availWidth;
  
    return deviceWidth>1400;
  }
  
  export default CustomLandscapeWidest;
  